import { CHAT_STATUS, NotificationStatus } from "@/types";

export const NOTIFICATION_STYLES = {
  [NotificationStatus.DRAFT]: {
    title: "下書き",
    className: "bg-grey-600 size-2 rounded-full",
  },
  [NotificationStatus.NOTIFIED]: {
    title: "通知済",
    className: "bg-primary_light size-2 rounded-full",
  },
  [NotificationStatus.READY]: {
    title: "保存済",
    className: "bg-warning_main size-2 rounded-full",
  },
};

export const DROPZONE_ACCEPT = {
  IMAGE: {
    COMMON: {
      "image/jpeg": [".jpeg", ".jpg"],
      "image/png": [".png"],
    },
    ALL: {
      "image/jpeg": [".jpeg", ".jpg"],
      "image/png": [".png"],
      "image/gif": [".gif"],
      "image/webp": [".webp"],
      "image/svg+xml": [".svg"],
    },
  },
  VIDEO: {
    COMMON: {
      "video/mp4": [".mp4"],
    },
    ALL: {
      "video/mp4": [".mp4"],
      "video/quicktime": [".mov"], // mov
      "video/x-msvideo": [".avi"], // avi
      "video/x-matroska": [".mkv"], // mkv
      "video/webm": [".webm"],
    },
  },
  PDF: {
    "application/pdf": [".pdf"],
  },
};

export const CHAT_STATUS_STYLES = {
  [CHAT_STATUS.未対応]: "bg-social_red text-light_default", // 未対応
  [CHAT_STATUS.対応中]: "bg-green-150 text-success_dark", // 対応中
  [CHAT_STATUS.対応済]: "bg-grey-600/80 text-light_default", // 対応済
};
